<template>
  <div class="question-view-dialog hotspot" >

    <div class="quest">
      <div class="title">
        <vue-mathjax :formula="form.title" :safe="false"/>
      </div>
    </div>
    
    <div class="quest-img-dialog" :style="{backgroundImage: `url(${form.img_url || form.imgUrl})`}">
      <!-- <img :src="form.img_url" alt=""> -->
    </div>
  </div>
</template>

<script>
import HotspotDrag from './hotspotDrag/hotspotDrag'
import {_debounce} from '@/utils/throttle.js'

export default {
  props: ['form', 'mode'],
  data() {
    let letter = new Array(26).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

    return {
      letter,
      image: '',
      topic: '',
      hotspotData: [],

      drag: null,
      answer_results: {
        id: null,
        student_choices: []
      },
      recordQuestion: [],
      map: []
    }
  },
  watch: {
    'form.id': {
      handler(){
        this.initData()
      },
      deep: true
    }
  },
  methods: {
    // 重置
    resetting() {
      // 数据清空
      this.$emit('permissions', false)

      // 清空样式
      let blocks = document.querySelectorAll('.block-style')
      for(let i = 0; i < blocks.length; i++) {
        let block = blocks[i]
        if(block.dataset.mark == 1) block.click()
      }
    },
    showTrueFalse() {
      let { form, recordQuestion } = this,
      answers = form.answers.map(its => its.choice_id),
      blocks = document.querySelectorAll('.block-style')

      for(let i = 0; i < blocks.length; i++) {
        let block = blocks[i],
        {value} = block.dataset
        if(recordQuestion.some(its => its.choice_id == value)) {
          block.click()
        }
      }

      for(let i = 0; i < blocks.length; i++) {
        let block = blocks[i],
        {value, mark} = block.dataset

        if(mark != 1) continue;
        if(answers.includes(Number(value))) {
          block.classList.add('block-style-success')
        } else {
          block.classList.add('block-style-error')
        }
      }
    },
    sizeEvent() {
      // 获取quest-img-dialog宽高比例
      let imgDom = document.querySelector('.quest-img-dialog'),
      iWidth = imgDom.clientWidth,
      imgBl = iWidth / 833,
      iHeight = 500 * imgBl

      imgDom.style.height = iHeight + 'px'
      // console.log(this.map)
      // 获取block-style宽高
      // let block = document.querySelectorAll('.block-style')
      for(let i = 0; i < this.map.length; i++) {
        let {width, height, x, y, uuid} = this.map[i], 
        block = imgDom.querySelector(`#${uuid}`),
        bl = imgBl * 500 / 300

        if(block) {
          block.style.width = `${width * bl}px`
          block.style.height = `${height * bl}px`
          block.style.top = `${y * bl}px`
          block.style.left = `${x * bl}px`
        }
      }
    },
    initData() {
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.recordQuestion = []
      this.hotspotData = []

      this.drag = new HotspotDrag({
        plate: '.quest-img-dialog',
        useType: 'view',
      })
      // let content = JSON.parse(this.form.content)
      // console.log(content)
      this.map = []
      for(let i = 0; i < this.form.choices.length; i++) {
        let its = this.form.choices[i]
        this.map.push({
          ...JSON.parse(its.value),
          other: {
            id: its.id,
            position: its.position,
            type: its.type
          }
        })
      }
      this.drag.echoBlock(this.map, this)

      if(this.mode == 'viewAnswer') setTimeout(() => this.showTrueFalse(), 500)
      this.sizeEvent()
    }
  },
  created() {
    // transfer.$on('hotspot', ({image, topic, hotspotData}) => {
    //   this.image = image
    //   this.topic = topic
    //   this.hotspotData = hotspotData

    //   this.drag && this.drag.echoBlock(hotspotData, this)
    // })

  }, 
  mounted() {
    this.initData()
    window.onresize = _debounce(this.sizeEvent, 500)
  }
}
</script>

<style scoped lang="scss">
.question-view-dialog {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;
  .quest {
    flex: 1;
    height: 100%;

    .title {
      font-size: 15px;
      color: #333;
    }

  }
  .quest-img-dialog {
    width: 833px;/*width: 833px;*/
    height: 500px;
    background-color: #fff;
    background-size: 100% 100%;
    position: relative;
    .img-region {
      position: relative;
      display: flex;
      overflow: hidden;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        position: absolute;
        background-color: #fff;
        color: #333;
      }

      &:after, &:before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: -50%;
        margin: auto;
        height: 1px;
        width: 200%;
        background-color: #fff;
        transform: rotateZ(45deg);
      }

      &:before {
        transform: rotateZ(-45deg);
      }
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>

<style lang="scss">
.click-style {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  display: none;

  &:before {
    content: '';
    position: absolute;
    top: -5px;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 10px;
    height: 20px;
    border: 3px solid #007516;
    border-top: none;
    border-left: none;
    transform: rotateZ(50deg);
  }
}

.block-style-circle {
  position: absolute;
  top: 80px;
  left: 80px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
  background-color: transparent;
  background-size: 100% 100%;

  
  &:before {
    content: '';
    border-radius: 50%;
  }
}

.block-style {
  width: 80px;
  height: 80px;
  position: absolute;
  top: 80px;
  left: 80px;
  cursor: pointer;
  z-index: 1;
  background-size: 100% 100%;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px dashed #333;
  }
}
</style>